import {getCookie} from "../utils/cookies";
import {accessTokenKey} from "../core/AuthInterceptor";
import {Navigate, Outlet} from "react-router-dom";

const AuthenticationRequiredGuard = () => {
    const token = getCookie(accessTokenKey);

    if (!token) return <Navigate to="/login" replace />;
    return <Outlet />;
};

export default AuthenticationRequiredGuard;